import React from 'react';

import svg from './assets/icons-16-description.svg';
import type { IconProps } from './SvgIcon';
import { SvgIcon } from './SvgIcon';

export const IconDescription = (props: IconProps) => (
  <SvgIcon {...props} src={svg} testId="icon-description" />
);
